<div class="editor-tag" (click)="focusTagInput()">
  @for (tag of tags; track tag) {
    <span class="tag-item">
      {{tag}}
      <span class="remove-tag" (click)="removeTag(tag)">×</span>
    </span>
  }
  <input placeholder="Enter...." #tagInput type="text" class="input-tag" (keyup)="onKeyUp($event)" [(ngModel)]="name" (focusout)="sendVal();">
</div>